import MagnifyingGlass from "./assets/magnifying-glass.svg"
import useStyles from "./styles"
import { strings as Localization } from "../../lib/Localization"
import { setSearchQuery } from "../../redux/searchReducer"
import { useSearchQuery } from "../../redux/hook/searchHooks"
import { useSteering } from "../../redux/hook/userHooks"
import { clearSearchResult } from "../../redux/productReducer"
import { setShowNavbarSearch } from "../../redux/settingsReducer"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import React, { useEffect, useState } from "react"

const AsyncSearch = ({ style, ...props }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState("")
    const [_query, setQuery] = useState("")

    const steering = useSteering()
    const language = useLanguage()
    const navigate = useNavigate()

    const handleEdit = e => {
        setSearchText(e.target.value)
    }

    const searchOnText = () => {
        const ignoreSteering = Boolean(
            searchText.trim().match(/^\d\d\d\d\d\d$/)
        )

        const steeringText = !ignoreSteering ? `&steering=${steering}` : ""

        navigate(`/${language}/filter?texts=${searchText}${steeringText}`)
    }

    const handleKeyUp = e => {
        if (e.keyCode === 13) {
            dispatch(setShowNavbarSearch(false))
            searchOnText()
        }
    }

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setQuery(searchText)
        }, 750)

        return () => clearTimeout(delayDebounceFn)
    }, [searchText])

    return (
        <div className={classes.wrapper}>
            <div
                style={{
                    display: "flex", gap: 10, ...style
                }}
                {...props}
            >
                <img loading="lazy" src={MagnifyingGlass} width="19px" height="22px" alt="Search icon" />
                <div className={classes.searchInputWrapper}>
                    <input
                        className={classes.searchInput}
                        onKeyUp={handleKeyUp}
                        onChange={handleEdit}
                        value={searchText}
                        placeholder={Localization.searchForProducts}
                    />
                </div>
            </div>
        </div>
    )
}

export default AsyncSearch
